<template>
    <ul class="m-counter flex jc-sb" :class="step > 0 ? '_show':'_hide'">
      <li class="m-counter--item" v-for="(item, key) in total" :key="key" :class="{'m-counter_active': step > key }"></li>
    </ul>
</template>

<script>
export default {
  name: 'Counter',
  props: {
    step: Number,
    total: Number
  }
}
</script>

<style scoped lang="scss">
.m-counter{
  position: absolute;
  top: 110px;
  right: 0;
  width: 250px;
  padding: 0 20px;
  z-index: 2;
  transition: .4s;
  &--item{
    position: relative;
    height: 34px;
    width: 19px;
    margin:0 1.5px;
    &:before{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      background: url(~@/assets/counter.png)center center/contain no-repeat;
      height: 100%;
      width: 100%;
      pointer-events: none;
    }
  }
   &._hide{
     opacity: 0;
     transform: translate3d(0, 50px, 0);
   }
   &._show{
     opacity: 1;
     transform: translate3d(0, 0, 0);
   }
   &_active{
     &:before{
       content: '';
       position: absolute;
       top: 0;
       left: 0;
       background: url(~@/assets/counter-active.png)center center/contain no-repeat;
       height: 100%;
       width: 100%;
       z-index: 1;
     }
   }
  @include respond-to(sm) {
    top: 130px;
    right: 50px;
    width: 320px;
    padding: 0;
    &--item{
      height: 34px;
      width: 19px;
    }
  }
   @include respond-to('1200') {
    top: 100px;
   }
}
</style>
